module.exports = __webpack_public_path__ + "2f6b40d1a55df6bed7b60602b7961c00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/keurig_dr_pepper_2022_chart.png
// module id = 1691
// module chunks = 0